import React from "react";
import { Modal, Button, Tab, Tabs } from "react-bootstrap";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import ConfirmationModal from "../../../sub/modals/ConfirmationModal";
import Util from "../../../../util/Util";
import CompanyAddGeneralInfoModal from "./CompanyAddGeneralInfoModal";
import CompanyAddCrmConnect from "./CompanyAddCrmConnect";
import {
  checkIfCompanyUrlExists,
  createCompany,
  updateCompany,
} from "../../../../actions/clients/company/company";
import CompanyDevices from "./CompanyDevices";

class CompanyAddModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      company_name: undefined,
      url: undefined,
      modal: null,
      company_nameError: null,
      urlError: null,
    };
    if (this.props.company !== undefined) {
      this.state = {
        company_name: this.props.company.name,
        url: this.props.company.url,
      };
    }
  }

  close() {
    this.props.close();
  }

  stopEvent(e) {
    e.stopPropagation();
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    // No previous error
    if (this.hasError()) return;

    let data = null;

    if (this.props.company === undefined) {
      data = {
        name: this.state.company_name,
        url: this.state.url,
      };

      // Send company information and redirect on success
      this.props.onCompanyCreate(
        data,
        () => this.close(),
        (e) => console.log(e),
      );
    } else {
      data = {
        _id: this.props.company._id,
        name: this.state.company_name,
        url: this.state.url,
      };
      // Send company information and redirect on success
      this.props.onCompanyEdit(
        data,
        () => this.close(),
        (e) => console.log(e),
      );
    }
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ConfirmationModal
          isOpen={true}
          size="md"
          title={title}
          content={content}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  hasEmptyField() {
    return !this.state.company_name || !this.state.url;
  }

  hasError() {
    return this.state.urlError || this.state.company_nameError;
  }

  onChange(field, value) {
    this.setState({ [field]: value });

    // Check if company_name is not empty
    if (field === "company_name" && !Util.emptyString(value)) {
      this.setState({ company_nameError: null });
      // Check if company_name < 50
      if (value.length > 50) {
        this.setState({
          company_nameError: <FormattedMessage id="Character.Max" />,
        });
      }
      // Check company_name regex
      const regex = /[A-Z.'\s\-0-9]/g;
      const found = value.match(regex);
      if (
        (found === null && value.length !== 0) ||
        found.length < value.length
      ) {
        this.setState({
          company_nameError: <FormattedMessage id="Character.Type" />,
        });
      }
    }

    // Check if email is not empty and not already taken
    if (field === "url" && !Util.emptyString(value)) {
      this.props.onCheckIfCompanyUrlExists(
        value,
        () => {
          this.setState({
            urlError: <FormattedMessage id="URL.Already.Taken" />,
          });
        },
        () => this.setState({ urlError: null }),
      );

      if (value.length > 20) {
        this.setState({
          urlError: <FormattedMessage id="Character.Max" />,
        });
      }
      // Check company_name regex
      const regex = /[a-z0-9]/g;
      const found = value.match(regex);
      if (
        (found === null && value.length !== 0) ||
        found.length < value.length
      ) {
        this.setState({
          urlError: <FormattedMessage id="Character.Type.AlphaNum" />,
        });
      }
    }
  }

  render() {
    var dclassname = "disabled";
    if (this.props.company !== undefined) dclassname = "";

    var target = "general";

    return (
      <>
        {!this.state.modal && (
          <Modal
            show={true}
            size="lg"
            onHide={() => this.close()}
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {this.props.company === undefined ? (
                  <FormattedMessage id="Pharmacy.Add" />
                ) : (
                  <FormattedMessage id="Pharmacy.Update" />
                )}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Tabs defaultActiveKey={target} id="patientsTabs">
                <Tab
                  eventKey="general"
                  title={this.props.intl.formatMessage({ id: "General" })}
                  tabClassName={"text-brown"}
                >
                  <CompanyAddGeneralInfoModal
                    company={this.props.company}
                    close={() => this.props.close()}
                  />
                </Tab>
                <Tab
                  eventKey="must"
                  title={this.props.intl.formatMessage({
                    id: "API.CRM.Connection",
                  })}
                  tabClassName={dclassname + " text-brown"}
                >
                  <CompanyAddCrmConnect
                    openConfModal={(title, content, successCallback) =>
                      this.openConfModal(title, content, successCallback)
                    }
                    close={() => this.props.close()}
                    company={this.props.company}
                  />
                </Tab>
                {this.props.company && (
                  <Tab
                    eventKey="devices"
                    title={this.props.intl.formatMessage({
                      id: "Devices",
                    })}
                    tabClassName={dclassname + " text-brown"}
                    mountOnEnter
                  >
                    <CompanyDevices
                      close={() => this.props.close()}
                      companyId={this.props.company._id}
                    />
                  </Tab>
                )}
              </Tabs>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={() => this.close()}>
                <FormattedMessage id="Cancel" />
              </Button>
              {/* <Button variant="btn btn-info" onClick={() => this.confirm()}><FormattedMessage id="Confirm" /></Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {this.state.modal}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCheckIfCompanyUrlExists: (url, existsCallback, noExistsCallback) =>
      checkIfCompanyUrlExists(url, existsCallback, noExistsCallback),
    onCompanyCreate: (data, successCallback, failureCallback) =>
      dispatch(createCompany(data, successCallback, failureCallback)),
    onCompanyEdit: (data, successCallback, failureCallback) =>
      dispatch(updateCompany(data, successCallback, failureCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyAddModal));
